import React from 'react';
import {Icon, Flex, Button, TimePicker, DatePicker, Submit, Form, Layout, Breadcrumbs} from 'components';
import {over, moment} from 'helpers';
import {reschedule} from 'store/activities';
import css from './reschedule.module.scss';

export function Reschedule({activity, contextDate, modal, occurance}) {
  modal.setClassName('wide');
  if (!activity.repeatType && activity.ts) {
    contextDate = moment.unix(activity.ts);
  }
  const initialValues = {
    contextDate,
    date: contextDate,
    id: activity.id,
    occurance,
    time: occurance?.priority ?? activity.time ?? ''
  };
  return (
    <Form delay className={css.modal} initialValues={initialValues} onSubmit={over(reschedule, modal.close)}>
      { ({values, setFieldValue}) =>
        <>
          <Layout.Header>
            <Flex className="justified">
              <Breadcrumbs>
                Reschedule
                {activity.name}
                <span className="long">
                  {contextDate.calendar()}
                  {values.time !== initialValues.time && ' '.concat(initialValues.time || '')}
                  {!isSame(initialValues, values) &&
                    <>
                      {' → '}
                      {!values.date.isSame(initialValues.contextDate) && values.date.calendar()}
                      {values.time !== initialValues.time && ' '.concat(values.time)}
                    </>
                  }
                </span>
              </Breadcrumbs>
              <Icon name="close" onClick={modal.close} />
            </Flex>
          </Layout.Header>
          <DatePicker
            dropdownMode={false}
            name="date"
            onChange={date => setFieldValue('date', date)}
            openToDate={(values.date).toDate()}
            selected={values.date}
          />
          <Flex className={['medium-spacing']}>
            <TimePicker label="Time" name="time" className="pull-left" />
            { !activity.repeatType &&
              <Button onClick={over(() => reschedule({...values, date: null}), modal.close)}>
                Due Someday
              </Button>
            }
            <Submit disabled={isSame(initialValues, values)}>
              {[!isSame(initialValues, values) ? 'Confirm' : 'Pick a date..', 'Rescheduling..']}
            </Submit>
          </Flex>
        </>
      }
    </Form>
  );
}

const isSame = (initial, values) => {
  if (!values.date.isSame(initial.contextDate)) {
    return false;
  }
  if (values.time !== initial.time) {
    return false;
  }
  return true;
};
